import { type SvgProps, SvgWrapper } from '../utils';

export function TrendingUpIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M21.25 13V7.75H16C15.5858 7.75 15.25 7.41421 15.25 7C15.25 6.58579 15.5858 6.25 16 6.25H22C22.4142 6.25 22.75 6.58579 22.75 7V13C22.75 13.4142 22.4142 13.75 22 13.75C21.5858 13.75 21.25 13.4142 21.25 13Z" />
      <path d="M21.4697 6.46973C21.7626 6.17683 22.2374 6.17683 22.5303 6.46973C22.8232 6.76262 22.8232 7.23738 22.5303 7.53027L14.0303 16.0303C13.7374 16.3232 13.2626 16.3232 12.9697 16.0303L8.5 11.5605L2.53028 17.5303C2.23738 17.8232 1.76262 17.8232 1.46973 17.5303C1.17684 17.2374 1.17684 16.7626 1.46973 16.4697L7.96973 9.96973L8.02637 9.91797C8.32095 9.67766 8.75567 9.69512 9.03028 9.96973L13.5 14.4395L21.4697 6.46973Z" />
    </SvgWrapper>
  );
}
